import { render, staticRenderFns } from "./UcRegister.yaml?vue&type=template&id=5f0c8d3f&component"
import script from "./UcRegister.yaml?vue&type=script&lang=ts&component"
export * from "./UcRegister.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports